import React, {forwardRef} from 'react';
import {FondoPrestacion} from "./FondoPrestacion";
import PropTypes from "prop-types";


export const FondoPrintAll =forwardRef(({datafondo}, ref)  => {

    return (
        <div ref={ref}>
            {datafondo.length > 0 && datafondo.map((datafondo, i) => <div key={i} className='mx-auto '>
                <FondoPrestacion
                    datafondo={datafondo}
                />
                <hr  style={{borderBottomWidth: '30px'}} className="mt-20 border-white"/>
            </div>)}
        </div>
    );
});



FondoPrintAll.prototype = {
    datafondo: PropTypes.array,
}

FondoPrintAll.defaultProps = {
    datafondo: [],
}


